import { createAction } from "@reduxjs/toolkit";
import { signUpActionTypes, signUpModalType } from "./actionTypes";

export const signUp = createAction(signUpActionTypes.request, (payload) => ({
  payload,
}));

export const signUpSuccess = createAction(
  signUpActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const signUpFailure = createAction(
  signUpActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const signUpReset = createAction(signUpActionTypes.reset);

export const toggleSignUpModal = createAction(signUpModalType);
